import { Vue, Component, Prop, Inject } from 'vue-property-decorator';
import { MAudio } from "@/utils/audio";
import { notLoginErrorMessage, showConfirmDialog } from '@/utils/util'
import { judgeDeviceType } from "@/utils/device";
import moduleStore from '../../store/searchSpeaker';
import PlayLottie from '@/views/searchSpeaker/components/playLottie/playLottie.vue'
@Component({
  components: {
    PlayLottie
  },
  // computed:{
  //   currentClickSpeakerId(){
  //     return this.currentClickIndx;
  //   }
  // }
})
@moduleStore.initVuex({
  mutationNames:moduleStore.mutationNames,
  actionNames:moduleStore.actionNames
})
export default class SpeakerCards extends Vue{
  @Prop()speakerResults: Array<any>;
  @Prop()theme: string;
  // 需要过滤掉的音色名称（本体名）
  FILTER_SPEAKER_NAMES = ['魔大佐', '魔太君','魔大佐Pro'];
  // @Prop()currSpeakerId: number;
  currentClickIndx = null;
  currentClickSpeakerId = null;//当前点击的发音人id
  speakerAudio = null;//发音人视频音频对象
  heartWhite = require('/public/images/video_editor/heart_white.png');
  heartRed = require('/public/images/video_editor/heart_red.png');
  newYearHeartWhite = require('/public/images/migu/heart_icon.png');
  newYearHeartRed = require('/public/images/migu/heart_red.png');
  // 选中角标
  cornerMarkIcon = require('/public/images/migu/corner_mark_icon.png');
  playState = "initial";//播放状态
  isVip = false;
  isApp = judgeDeviceType.isAPP;
  
  // 过滤掉指定音色用于模板渲染
  get displaySpeakerResults(): Array<any> {
    if (!this.speakerResults) return [];
    return this.speakerResults.filter(item => {
      const baseName = (item.name || '').split('|')[0];
      return !this.FILTER_SPEAKER_NAMES.includes(baseName);
    });
  }
  
  created(){
    this.speakerAudio = MAudio.listen({//试听发音人声音
      playing: () => {
        this.playState = "playing";
      },
      pause: () => {
        this.playState = "paused";
      },
      ended: () => {
        this.playState = "initial";
      }
    });
  }
  mounted(){
    console.log('--mounted',this.currentClickSpeakerId,this.speakerResults)
    // 如果页面传参vip，则不需要加锁
    const vip = this.$route.query.vip;
    if(vip) {
      this.isVip = true;
      return;
    }
    this.getVipInfo();
  }
  destroy() {
    this.cancelListen();
  }
  /**
   * 收藏图标
   * @param speaker
   * @returns 
   */
  getFavouriteIcon(speaker) {
    if (this.theme === 'New_Year') {
      return speaker.isFavourite? this.newYearHeartRed : this.newYearHeartWhite
    }
    return speaker.isFavourite? this.heartRed : this.heartWhite
  }
  getVipInfo() {
    const ww_token = localStorage.getItem('ww_token');
    if(!ww_token) return;
    this.$http('queryMemberLeftRight')
      .then((res) => {
        const { code, data, message } = res
        if (code === 200) {
          // 会员权益
          this.isVip = data.vipRightsVO.isVip
        } else {
          console.error(message)
        }
      })
  }
  tryListing(speaker){
    if(this.currentClickSpeakerId!=null && this.currentClickSpeakerId === speaker.defaultSpeaker.speakerId &&this.playState === "playing"){
      this.speakerAudio.stop();
      this.playState = "initial";
    }else{ 
      console.log('--换了发音人',speaker.defaultSpeaker)
      this.currentClickSpeakerId = speaker.defaultSpeaker.speakerId;
      
      let demoUrl = speaker.speakerEmotionCacheVOList[0].demoUrl;
      if(demoUrl){
        this.speakerAudio.setSrc(demoUrl);
        this.speakerAudio.play();
        this.playState = "playing";
      }
    }
    this.$emit('setCurrentSpeaker',speaker)
  }
  doClickLock() {
    if(this.isApp) {
      this.$toast({
        message: '成为会员解锁声音',
        duration: 3000
      });
    }

    showConfirmDialog({
      message: '成为会员解锁声音',
      confirmButtonText: '前往了解',
    }).then(() => {
      const ww_token = localStorage.getItem('ww_token');
      if(!ww_token) {
        this.$emit('doLogin');
        return;
      }
      this.$navigateTo({
        url: '/mine-package/pages/recharge-vip/recharge-vip'
      })
    })
  }
  selectCurrentSpeaker(speaker){
    if(speaker.defaultSpeaker.speakerId !=this.currentClickSpeakerId ){
      this.speakerAudio.stop();
      this.playState = "initial";
      this.currentClickSpeakerId = speaker.defaultSpeaker.speakerId;
      this.tryListing(speaker);
    }
    this.$emit('setCurrentSpeaker',speaker)
  }
  cancelListen(){
    console.log('--发音人卡片取消试听')
    this.playState = "initial";
    this.speakerAudio&&this.speakerAudio.stop();
  }
  //收藏
  clickCollect(speaker){
    console.log('--收藏',speaker)
    this.setFavouritesFn(speaker.builderId);
  }
  setFavouritesFn(builderId){
    let params={
      builderId:builderId,
      voiceType:0
    };
    this.$http('collectSave',params).then(res=>{
      console.log('--收藏返回',res)
      if(res.code===200){
        // let isFavourite = false;//当前是收藏/取消收藏
        //前端页面更新该条数据收藏状态
        let index = this.speakerResults.findIndex(speaker=>speaker.builderId===builderId);
        console.log('--收藏返回',index)
        let targetSpeaker:any = {};
        if(index > -1){
          targetSpeaker = this.speakerResults[index];
          // targetSpeaker.isFavourites = !targetSpeaker.isFavourites;
        }
        this.speakerResults[index].isFavourite = !this.speakerResults[index].isFavourite;
        this.$emit('change-favourite', this.speakerResults[index])
        console.log('--收藏返回',this.speakerResults[index])
        let title = "";
        if (targetSpeaker.isFavourite) {
          title = "收藏成功";
        } else {
          title = "取消收藏";
        }
        this.$toast(`${title}`);
      }
    }).catch(err => {
      if(err?.response?.data?.message === notLoginErrorMessage){
        this.$emit('doLogin');
      }
    })
  }
}